import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatPhone'
})
export class FormatPhonePipe implements PipeTransform {
    transform(phoneNumber: string, phoneCode: string, countryCode: string): string {
        const countriesNeedRemoveZero = ['VN', 'FR', 'JP', 'KR', 'GB', 'CN'];

        if (!phoneNumber || !phoneCode || !countryCode) return '';

        let normalized = phoneNumber.trim();

        if (countriesNeedRemoveZero.includes(countryCode.toUpperCase()) && normalized.startsWith('0')) {
            normalized = normalized.slice(1);
        }

        return `(${phoneCode}) ${normalized}`;
    }
}
